<template>
  <v-stepper v-model="step" vertical style="background: linear-gradient(rgba(220, 53, 69, 0.35), rgba(220, 53, 69, 0.50)), url(http://eed.eg/images/headerimg.png); background-size: cover; background-attachment:fixed;" ref="stepsBar">
    <v-stepper-header style="background: #f44336;color: white;font-weight: bold;">
      <v-stepper-step step="1" :complete="step > 1">Competition Details</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="2" :complete="step > 2">Terms & Conditions</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="3" :complete="step > 3">Education Details</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="4" :complete="step > 4">Project Name</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="5" :complete="step > 5">Members</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="6" :complete="step > 6">Supervisor</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="7" :complete="step > 7">Project Details</v-stepper-step>
      <v-divider></v-divider>
      <!-- <v-stepper-step step="8" :complete="step > 8">Equipments</v-stepper-step>
      <v-divider></v-divider> -->
      <v-stepper-step step="8" :complete="step > 9">Project Submit</v-stepper-step>
    </v-stepper-header>
    <v-content v-if="!dataReady">
      <v-container grid-list-xl>
        <v-layout align-center justify-center>
          <v-flex xs1 sm1 md1>
            <v-progress-circular :size="50" indeterminate color="red darken-4"></v-progress-circular>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center>
          <p class="title red--text text--darken-4">Loading form, please wait ...</p>
        </v-layout>
      </v-container>
    </v-content>
    <v-content v-if="submittingDone">
      <v-container grid-list-xl>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md8>
            <p class="title red--text text--darken-4">Thank you for registration in MIE 2021! You will receive a confirmation mail shortly.</p>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-stepper-content step="1">
      <app-competition v-if="dataReady" style="background: rgba(255, 240, 210, 0)" v-model="user.data" @completed="goToNextStep" :user="user" :competitions="response.competitions"></app-competition>
    </v-stepper-content>
    <v-stepper-content step="2">
      <app-terms v-if="viewForm" style="background: rgba(255, 240, 210, 0)" @completed="goToNextStep" @rollback="goToPreviousStep" :user="user" :competitions="response.competitions"></app-terms>
    </v-stepper-content>
    <v-stepper-content step="3">
      <app-cities v-if="viewForm" style="background: rgba(255, 240, 210, 0)" @completed="goToNextStep" @rollback="goToPreviousStep" :colleges="response.colleges" :user="user" :cities="response.cities"></app-cities>
    </v-stepper-content>
    <v-stepper-content step="4">
      <app-project v-if="viewForm" style="background: rgba(255, 240, 210, 0)" @completed="goToNextStep" @rollback="goToPreviousStep" :user="user" :items="response.items" :original_items="response.original_items"></app-project>
    </v-stepper-content>
    <v-stepper-content step="5">
      <app-members v-if="viewForm" style="background: rgba(255, 240, 210, 0)" @completed="goToNextStep" @rollback="goToPreviousStep" :user="user" :cities="response.cities" :items="response.items"></app-members>
    </v-stepper-content>
    <v-stepper-content step="6">
      <app-supervisors v-if="viewForm" style="background: rgba(255, 240, 210, 0)" @completed="goToNextStep" @rollback="goToPreviousStep" :user="user" :cities="response.cities" :items="response.items"></app-supervisors>
    </v-stepper-content>
    <v-stepper-content step="7">
      <app-questions v-if="viewForm" style="background: rgba(255, 240, 210, 0)" :questions="response.questions" @completed="goToSubmit" @rollback="goToPreviousStep" :user="user"></app-questions>
    </v-stepper-content>
    <!-- <v-stepper-content step="8">
      <app-items v-if="viewForm" style="background: rgba(255, 240, 210, 0)" :items="response.items" @completed="goToSubmit" @rollback="goToPreviousStep" :cities="response.cities" :user="user" :original_items="response.original_items"></app-items>
    </v-stepper-content> -->
    <v-stepper-content step="8">
      <app-submit v-if="viewForm && submitted" style="background: rgba(255, 240, 210, 0)" @completed="submitForm" @rollback="goToPreviousStep" :user="user" :competitions="response.competitions"  :colleges="response.colleges" :cities="response.cities" :items="response.items" :questions="response.questions" :submitting="submitting"></app-submit>
    </v-stepper-content>
  </v-stepper>      
</template>
<script>
import Competition from './Competition';
import Project from './Project';
import Cities from './Cities';
import Members from './Members';
import Supervisors from './Supervisors';
import Questions from './Questions';
import Items from './Items';
import Submit from './Submit';
import Terms from './Terms';
export default {
  name: 'App',
  components : {
    'app-competition' : Competition ,
    'app-cities' : Cities ,
    'app-project' : Project ,
    'app-members' : Members ,
    'app-questions' : Questions ,
    'app-items' : Items ,
    'app-supervisors' : Supervisors,
    'app-submit': Submit,
    'app-terms': Terms
  },
  created(){
    this.setData();
  },
  data(){
    return {
      dataReady: false,
      submitting: false,
      submittingDone: false,
      submitted: false,
      step: 1,
      biggestStep: 1,
      user : {
        data : {
          competition_id : null,
          category_id : null,
          city_id : null,
          college_id: null,
          city_accommodation: false,
          accommodated: false,
          members : [],
          answers : [],
          items : [],
          build_id: 6,
          total_price: 0,
          competition_change: true,
          item_changed: false
        },
      },
      response: {},
    }
  },
  computed: {
    viewForm() {
      return (this.dataReady && !this.submittingDone)
    }
  },
  methods : {
    setData(){
      axios.get('https://reg.ieeeypegypt.org/api/project-data').then( (response) => {
        let items = []
        this.response = response.data
        this.response.original_items = JSON.parse(JSON.stringify(response.data.items)) // stupid clone work around
        for (let key in this.response.original_items ) {
          let item = this.response.original_items[key]
          items.push({ item_id : item.id , quantity : item.min_quantity});
        }
        this.response.default_logistics = items;
        this.dataReady = true
      }).catch((error) => {
        this.$noty.error('An Error has Occured, Please check you connection!');
      })
    },
    goToSubmit(user) {
      this.goToNextStep(user);
      this.submitted = false;
      this.submitted = true;
    },
    goToNextStep(user){
      this.user= user;
      if (this.step == this.biggestStep) {
        this.biggestStep++;
      }
      this.step++;
      this.$refs.stepsBar.scrollTop = 0;
    },
    goToPreviousStep(user){
      this.user = user;
      this.step--;
      this.$refs.stepsBar.scrollTop = 0;
    },
    submitForm(user){
      this.submitting = true;
      this.user = user;
      let data = {
        name : this.user.data.project.name,
        affiliation_type : this.user.data.affiliation_type,
        category_id : this.user.data.category_id,
        sub_category_id : this.user.data.sub_category_id || null,
        college_id : this.user.data.college_id || null,
        city_id : this.user.data.city_id ,
        department_id : this.user.data.department_id || null,
        university_id : this.user.data.university_id || null,
        build_id : this.user.data.build_id,
        school_name : this.user.data.school_name || '',
        spec_length : 0,
        spec_width : 0,
        spec_height : 0,
        spec_weight : 0,
        members : this.user.data.members,
        supervisor : this.user.data.supervisor[0],
        answers : this.user.data.answers,
        logistics : this.response.default_logistics,
        build_id: 6,
        is_entr_project: 0
      }

      axios.post('/post-data',data).then((response) => {
        this.$noty.success('Form is submitted sucessfully !')
        this.submitting = false;
        this.submittingDone = true;
        setTimeout(function() {
          window.location.href = 'http://www.mie.eg';
        }, 10000);
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$noty.error('Unauthorized request');
        } else if (error.response.status === 422) {
          let errors = error.response.data;
          let errorsList = [];

          for (var key in errors) {
            if (errors.hasOwnProperty(key)) {
              error = errors[key];
              if (errorsList.indexOf() == -1) {
                this.$noty.error(error);
              }
            }
          }
        } else {
          this.$noty.error('An Error has occured, Please Try again');
        }
        this.submitting = false;
      })     
    }
  }
};
</script>
<style>
#app {
font-family: 'Avenir', Helvetica, Arial, sans-serif;
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
text-align: center;
color: #2c3e50;
margin-top: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/Registeration/Registeration.vue